<template lang="pug">
  .cardPassenger(:class="[{'passangerConfirmation': confirmation}, { 'passengerInactive': !confirmation && !activated }]" :style="{ height:  elHeight}")
    .passangerConfirmation__container(v-show="confirmation")
      i.passangerConfirmation__iconCheck
      i.passangerConfirmation__iconEdit(@click.stop.prevent="setConfirmation") #[b Editar]
      h3.passangerConfirmation__name {{ name }}
      span.passangerConfirmation__label Passageiro {{setPassengerNumber}} #[b - {{ lblPassengerAge }}]

    .passengerInactive(v-show="!confirmation && !activated")
      h3.passengerInactive__title Passageiro {{setPassengerNumber}}

    form.cardPassenger__form(v-show="!confirmation && activated")
      h3.cardPassenger__form__title Passageiro {{ setPassengerNumber }} - #[b.cardPassenger__form__label(:class="{'highlightDate': birthdayValidation.type === 'error' }") {{ lblPassengerAge }}]

      .repeatLeadInfoCheckbox(v-if="lead && lead.leadName && lead.leadPhone")
        cp-checkbox(
          :name="`repeatLeadInfo${index+1}`"
          label="Mesmo nome e telefone informados anteriormente"
          :value="hasInfoFromLead"
          :disabled="!showInfoFromLead"
          @change="setInfoFromLead"
        )

      .genders
        .genders__male.radio
          input.radio__input(type="radio" :id="`maleGender${index+1}`" :name="`gender${index+1}`" value="M" v-model="gender" @change="setGender")
          label.label(:for="`maleGender${index+1}`") Masculino
        .genders__feminine.radio
          input.radio__input(type="radio" :id="`feminineGender${index+1}`" :name="`gender${index+1}`" value="F" v-model="gender" @change="setGender")
          label.label(:for="`feminineGender${index+1}`") Feminino

      cp-field(
        label="Nome completo"
        for="name"
        :id="`passengerName${index+1}`"
        type="text"
        name="name"
        placeholder="Ex: Fernando Souza dos Santos"
        transform="captalize"
        :maxlength="30"
        :value="name"
        :validation="nameValidation"
        :disabled="hasInfoFromLead && $v.name.isValidName"
        @change="setName"
      )
      span.cardPassenger__infoValidation(v-if="!$v.name.$error") Campo com limite de 30 caracteres

      .cardPassenger__form__groupFields
        cp-field(
          label="Data de nascimento"
          for="birthday"
          :id="`passengerBirthday${index+1}`"
          type="mask"
          name="birthday"
          placeholder="Somente números"
          :mask="['##/##/####']"
          :value="dateOfBirthDisplay"
          :validation="birthdayValidation"
          @change="setDateOfBirth"
        )

        cp-field(
          label="Telefone"
          :for="`phone${index+1}`"
          :id="`phone${index+1}`"
          type="mask"
          :name="`phone${index+1}`"
          placeholder="Somente números"
          transform="captalize"
          :mask="['(##) ####-####', '(##) #####-####']"
          :value="phone"
          :validation="phoneValidation"
          :disabled="hasInfoFromLead"
          @change="setPhone"
        )

      cp-field(
        label="CPF"
        for="cpf"
        :id="`passengerCpf${index+1}`"
        type="mask"
        name="cpf"
        placeholder="Somente números"
        :disabled="isUnderThen18 && showIsUnderThen18Checkbox"
        :class="[{ disabledCustom : isUnderThen18 && showIsUnderThen18Checkbox }, { passengerCpf : showIsUnderThen18Checkbox }]"
        :mask="['###.###.###-##']"
        :value="cpf"
        :validation="cpfValidation"
        @change="setCpf"
      )

    button.cardPassenger__form__button(type="buttom" :disabled="disableBtn" @click.stop.prevent="setConfirmation") confirmar passageiro
</template>

<script>
import { required, requiredUnless, helpers, numeric, minLength, maxLength } from 'vuelidate/lib/validators'
import { CPF } from 'cpf_cnpj'
import moment from 'moment'
import views from '@/mixins/views'

import CpField from '@/components/views/Field.vue'
import CpCheckbox from '@/components/ui/Checkbox.vue'

export default {
  name: 'passenger-form',
  props: ['numberOfPassengers', 'index', 'passenger', 'passengers', 'lead'],
  mixins: [views],
  components: { CpField, CpCheckbox },
  data () {
    return {
      name: this.passenger.name,
      cpf: this.passenger.cpf,
      cpfLegalResponsible: this.passenger.cpfLegalResponsible,
      nameLegalResponsible: this.passenger.nameLegalResponsible,
      dateOfBirth: this.passenger.dateOfBirth,
      dateOfBirthDisplay: this.passenger.dateOfBirthDisplay || null,
      lblAgeRange: this.passenger.lblAgeRange,
      confirmation: this.passenger.confirmation,
      isUnderThen18: this.passenger.isUnderThen18,
      isUnderThen40: this.passenger.isUnderThen40,
      isUnderThen64: this.passenger.isUnderThen64,
      isUnderThen75: this.passenger.isUnderThen75,
      isUnderThen85: this.passenger.isUnderThen85,
      isUnderThen99: this.passenger.isUnderThen99,
      gender: this.passenger.gender,
      phone: this.passenger.phone,
      activated: this.passenger.activated,
      hasInfoFromLead: this.passenger.hasInfoFromLead,
      showIsUnderThen18Checkbox: false,
      showInfoFromLead: true,
      elHeight: ''
    }
  },
  updated () {
    if (!this.showIsUnderThen18Checkbox) this.elHeight = ''
    this.showInfoFromLead = this.alreadyHasInfoFromLead()
  },
  computed: {
    disableBtn () {
      return this.$v.$invalid
    },
    lblPassengerAge () {
      return `Idade de ${this.lblAgeRange} anos`
    },
    setPassengerNumber () {
      const counter = this.index + 1
      return counter < 10 ? `0${counter}` : counter
    },
    validation () {
      return !this.$v.$invalid
    },
    nameValidation () {
      const validations = [
        {
          type: 'error',
          msg: 'Por favor, informe seu nome completo',
          valid: false
        },
        {
          type: 'error',
          msg: 'Por favor, informe seu nome',
          valid: false
        },
        {
          type: 'error',
          msg: 'O nome excede o limite de caracteres. Por favor, abrevie',
          valid: false
        }
      ]

      if (!this.$v.name.$invalid) return { valid: true }
      if (!this.$v.name.blackListName) return validations[1]
      if (!this.$v.name.isValidName) return validations[2]
      if (this.$v.name.$dirty && this.$v.name.$invalid) return validations[0]

      return {}
    },
    cpfValidation () {
      let validations = [
        {
          type: 'error',
          msg: 'Por favor, insira um CPF.',
          valid: false
        },
        {
          type: 'error',
          msg: 'CPF Inválido.',
          valid: false
        },
        {
          type: 'error',
          msg: 'Esse CPF já foi utilizado em outro passageiro.',
          valid: false
        },
        {
          msg: 'Verificando CPF...'
        }
      ]
      if (!this.isUnderThen18) {
        if (!this.$v.cpf.$invalid && this.cpf.length === 11) return { valid: true }
        if (this.$v.cpf.$dirty && this.$v.cpf.$invalid) {
          if (!this.$v.cpf.required) return validations[0]
          if (!this.$v.cpf.cpfValidator && this.$v.cpf.required) return validations[1]
          if (
            this.$v.cpf.cpfValidator &&
            !this.$v.cpf.isUnique &&
            !this.$v.cpf.$pending
          ) return validations[2]
          if (this.$v.cpf.cpfValidator && this.$v.cpf.$pending) return validations[3]
        }
      }

      return {}
    },
    cpfLegalResponsibleValidation () {
      let validations = [
        {
          type: 'error',
          msg: 'Por favor, insira um CPF.',
          valid: false
        },
        {
          type: 'error',
          msg: 'CPF Inválido.',
          valid: false
        },
        {
          type: 'error',
          msg: 'Esse CPF já foi utilizado em outro passageiro.',
          valid: false
        },
        {
          msg: 'Verificando CPF...'
        }
      ]
      if (this.isUnderThen18) {
        if (!this.$v.cpfLegalResponsible.$invalid && this.cpfLegalResponsible.length === 11) return { valid: true }
        if (this.$v.cpfLegalResponsible.$dirty && this.$v.cpfLegalResponsible.$invalid) {
          if (!this.$v.cpfLegalResponsible.required) return validations[0]
          if (!this.$v.cpfLegalResponsible.cpfLegalResponsibleValidator && this.$v.cpfLegalResponsible.required) return validations[1]
          if (
            this.$v.cpfLegalResponsible.cpfLegalResponsibleValidator &&
            !this.$v.cpfLegalResponsible.isUnique &&
            !this.$v.cpfLegalResponsible.$pending
          ) return validations[2]
          if (this.$v.cpfLegalResponsible.cpfLegalResponsibleValidator && this.$v.cpfLegalResponsible.$pending) return validations[3]
        }
      }

      return {}
    },
    nameLegalResponsibleValidation () {
      const validations = [
        {
          type: 'error',
          msg: 'Por favor, informe nome do responsável legal',
          valid: false
        }
      ]

      if (this.isUnderThen18) {
        if (!this.$v.nameLegalResponsible.$invalid) return { valid: true }
        if (
          !this.$v.nameLegalResponsible.blackListName ||
          (this.$v.nameLegalResponsible.$dirty && this.$v.nameLegalResponsible.$invalid)
        ) return validations[0]
      }

      return {}
    },
    phoneValidation () {
      const validations = [
        {
          type: 'error',
          msg: 'Por favor, insira um telefone.',
          valid: false
        },
        {
          type: 'error',
          msg: 'Por favor, insira um numero de telefone válido.',
          valid: false
        }
      ]
      if (!this.$v.phone.$invalid && this.phone.length >= 10) return { valid: true }
      if (this.$v.phone.$dirty) {
        if (!this.$v.phone.required) return validations[0]
        if (this.$v.phone.$invalid) return validations[1]
      }

      return {}
    },
    birthdayValidation () {
      let validations = [
        {
          type: 'error',
          msg: 'A data precisa ser anterior à data atual.',
          valid: false
        },
        {
          type: 'error',
          msg: 'Por enquanto, só temos plano pra menores de 99 anos.',
          valid: false
        },
        {
          type: 'error',
          msg: 'Data inválida.',
          valid: false
        },
        {
          type: 'error',
          msg: 'Informe a data de nascimento.',
          valid: false
        },
        {
          type: 'error',
          msg: 'A data de nascimento deve estar de acordo com a faixa de idade',
          valid: false
        }
      ]
      if (!this.$v.dateOfBirthDisplay.$invalid && this.dateOfBirthDisplay.length === 8) return { valid: true }
      if (this.$v.dateOfBirthDisplay.$invalid && this.$v.dateOfBirthDisplay.$dirty) {
        if (this.dateOfBirthDisplay.length === 0) return validations[3]
        if (!this.$v.dateOfBirthDisplay.isUnique) return validations[4]
        if (!this.$v.dateOfBirthDisplay.date && this.dateOfBirthDisplay.length > 0) return validations[2]
        if (this.$v.dateOfBirthDisplay.isLessThan1Day) return validations[1]
        if (this.$v.dateOfBirthDisplay.isGreaterThen69Years) return validations[0]
      }

      return {}
    },
    genderValidation () {
      const validations = [
        {
          type: 'error',
          msg: 'Por favor, informe seu gênero',
          valid: false
        }
      ]

      if (!this.$v.gender.$invalid) return { valid: true }
      if (!this.maleGender && !this.feminineGender) return validations[0]
      if (this.$v.gender.$dirty && this.$v.gender.$invalid) return validations[0]

      return {}
    }
  },
  methods: {
    setName (value) {
      this.name = value.trim()
      this.setDirty(this.$v.name)
      this.setDataChange()
    },
    setCpf (value) {
      this.cpf = value
      this.setDirty(this.$v.cpf)
      this.setDataChange()
    },
    setCpfLegalResponsible (value) {
      this.cpfLegalResponsible = value
      this.setDirty(this.$v.cpfLegalResponsible)
      this.setDataChange()
    },
    setNameLegalResponsible (value) {
      this.nameLegalResponsible = value.trim()
      this.setDirty(this.$v.nameLegalResponsible)
      this.setDataChange()
    },
    setDateOfBirth (value) {
      this.dateOfBirth = moment(value, 'DDMMYYYY').format('YYYY-MM-DD')
      this.dateOfBirthDisplay = value
      this.setDirty(this.$v.dateOfBirthDisplay)
      if (!this.$v.dateOfBirthDisplay.$invalid) {
        this.showIsUnderThen18Checkbox = moment().diff(this.dateOfBirth, 'years') < 18
        if (!this.showIsUnderThen18Checkbox || !this.isUnderThen18) this.resetDataLegalResponsible()
      }
      this.setDataChange()
    },
    setPhone (value) {
      this.phone = value
      this.setDirty(this.$v.phone)
      this.setDataChange()
    },
    setConfirmation () {
      this.confirmation = !this.confirmation

      this.setDataChange()
      if (this.confirmation && this.showIsUnderThen18Checkbox && this.elHeight) this.elHeight = '88px'
      if (!this.confirmation && this.showIsUnderThen18Checkbox && this.elHeight) this.elHeight = `${this.$el.clientHeight + 566}px`
      if (!this.confirmation && this.isUnderThen18) this.elHeight = `${this.$el.clientHeight + 826}px`

      this.confirmation && this.clickTracking()
    },
    setDataChange () {
      let data = {
        name: this.name,
        cpf: this.cpf,
        cpfLegalResponsible: this.cpfLegalResponsible,
        nameLegalResponsible: this.nameLegalResponsible,
        dateOfBirth: this.dateOfBirth,
        lblAgeRange: this.lblAgeRange,
        confirmation: this.confirmation,
        isUnderThen18: this.isUnderThen18,
        isUnderThen40: this.isUnderThen40,
        isUnderThen64: this.isUnderThen64,
        isUnderThen75: this.isUnderThen75,
        isUnderThen85: this.isUnderThen85,
        isUnderThen99: this.isUnderThen99,
        gender: this.gender,
        phone: this.phone,
        activated: this.activated,
        hasInfoFromLead: this.hasInfoFromLead
      }

      this.$emit('change', data)
    },
    cpfExists (value) {
      let passengers = this.passengers.filter((passenger) => passenger.cpf === value)

      return passengers.length <= 1
    },
    ageRangeValidation (value) {
      if (this.isUnderThen40) return !moment(value, 'DDMMYYYY').add(41, 'years').isBefore()
      else if (this.isUnderThen64) return !moment(value, 'DDMMYYYY').add(41, 'years').isAfter() && !moment(value, 'DDMMYYYY').add(65, 'years').isBefore()
      else if (this.isUnderThen75) return !moment(value, 'DDMMYYYY').add(65, 'years').isAfter() && !moment(value, 'DDMMYYYY').add(76, 'years').isBefore()
      else if (this.isUnderThen85) return !moment(value, 'DDMMYYYY').add(76, 'years').isAfter() && !moment(value, 'DDMMYYYY').add(85, 'years').isBefore()
      else if (this.isUnderThen99) return !moment(value, 'DDMMYYYY').add(86, 'years').isAfter() && !moment(value, 'DDMMYYYY').add(99, 'years').isBefore()

      return false
    },
    clickTracking () {
      window.dataLayer.push({
        event: 'viagem-ciclic',
        gaEventCategory: 'viagem-passageiros',
        gaEventAction: 'click',
        gaEventLabel: 'confirmar-passageiro'
      })
    },
    setIsUnderThen18WithoutCpf (value) {
      if (this.showIsUnderThen18Checkbox) {
        this.isUnderThen18 = value
        if (this.isUnderThen18) {
          this.elHeight = `${this.$el.clientHeight + 260}px`
          this.setCpf('')
        } else {
          this.elHeight = `${this.$el.clientHeight - 260}px`
          this.resetDataLegalResponsible()
        }
      }
    },
    resetDataLegalResponsible () {
      this.cpfLegalResponsible = ''
      this.nameLegalResponsible = ''
      this.isUnderThen18 = false
      this.setDataChange()
    },
    setGender (event) {
      const { value } = event.target
      this.gender = value
      this.setDirty(this.$v.gender)
      this.setDataChange()
    },
    setInfoFromLead (checked) {
      if (checked) {
        this.setName(this.lead.leadName)
        this.setPhone(this.lead.leadPhone)
        this.hasInfoFromLead = true
      } else {
        this.setName('')
        this.setPhone('')
        this.hasInfoFromLead = false
      }
    },
    alreadyHasInfoFromLead () {
      if (!this.passengers.some((passenger) => passenger.hasInfoFromLead)) return true
      if (this.passengers.some((passenger) => passenger.hasInfoFromLead) && this.hasInfoFromLead) return true
      return false
    }
  },
  validations () {
    let defaultValidation = {
      cpf: {
        required: requiredUnless('isUnderThen18'),
        cpfValidator: (value) => !this.isUnderThen18 ? CPF.isValid(value) : true,
        isUnique (value) { return !this.isUnderThen18 && CPF.isValid(value) ? this.cpfExists(value) : true }
      },
      name: {
        required,
        alphaWhiteDiacritic: helpers.regex('alphaWhiteDiacritic', /^[a-zA-ZÀ-ž.\s]*$/),
        fullName: helpers.regex('fullName', /.{2,}\s.{2,}/),
        blackListName: (value) => !(/((^|\s)((teste|test)(s)?)(\s|$))/i.test(value)),
        isValidName: (fullName) => {
          if (!fullName) return true

          const firstName = fullName.split(' ').slice(0, 1).join(' ')
          const lastName = fullName.split(' ').slice(1).join(' ')

          if (firstName.length > 30 || lastName.length > 30) return false

          return true
        }
      },
      dateOfBirthDisplay: {
        required,
        date: value =>
          moment(value, 'DDMMYYYY', true).isValid(),
        isGreaterThen69Years: value =>
          moment(value, 'DDMMYYYY')
            .add(99, 'years')
            .isAfter(),
        isLessThan1Day: value =>
          moment(value, 'DDMMYYYY')
            .add(1, 'day')
            .isBefore(),
        isUnique (value) { return this.ageRangeValidation(value) }
      },
      gender: {
        required
      },
      phone: {
        required,
        numeric,
        minLength: minLength(10),
        maxLength: maxLength(11),
        isValidNumber: (number) => {
          if (!number) return false
          const { groups } = /(?<codDDD>\d{2})(?<phone>.*)/.exec(number)
          const numberIsCell = number.length === 11

          if (/(.)\1{7,}/.test(groups.phone)) return false
          if (numberIsCell) if (/^[0-8]/.test(groups.phone)) return false
          if (/^0/.test(groups.codDDD)) return false
          return true
        }
      }
    }

    if (this.isUnderThen18) {
      const legalResponsibleValidation = {
        cpfLegalResponsible: {
          required,
          cpfLegalResponsibleValidator: value => CPF.isValid(value)
        },
        nameLegalResponsible: {
          required,
          alphaWhiteDiacritic: helpers.regex('alphaWhiteDiacritic', /^[a-zA-ZÀ-ž.\s]*$/),
          fullName: helpers.regex('fullName', /.{2,}\s.{2,}/),
          blackListName: (value) => !(/((^|\s)((teste|test)(s)?)(\s|$))/i.test(value))
        }
      }

      defaultValidation = { ...defaultValidation, ...legalResponsibleValidation }
    }

    return defaultValidation
  }
}
</script>

<style lang="scss">
@import '~@/style/ui/variables';
@import '~@/style/components/_checkbox';
@import '~@/style/components/_radio';

.cardPassenger {
  max-width: 600px;
  width: 100%;
  background-color: $white;
  border-radius: 8px;
  transition: height 300ms ease-in-out;
  border: solid 1px rgba(189, 194, 198, 0.4);
  position: relative;
  overflow: hidden;
  padding-left: 32px;
  padding-right: 32px;
  padding-bottom: 32px;
  margin-bottom: 40px;

  @media screen and (max-width: 768px) {
    padding-left: 24px;
    padding-right: 24px;
  }

  .highlightDate{
    color: #ff3b30
  }

  &.passangerConfirmation,
  &.passengerInactive {
    height: 88px;
  }

  &.passengerInactive {
    padding-top: 30px;
  }

  .repeatLeadInfoCheckbox,
  .isUnderThen18Checkbox {
    padding-top: 10px;
  }

  .repeatLeadInfoCheckbox {
    .label {
      @media screen and (max-width: 450px) {
        line-height: 27px;
        font-size: 12px;
      }

      @media screen and (max-width: 365px) {
        line-height: 12px;
      }
    }
  }

  &__infoValidation {
    font-size: 10px;
  }

  &__form {

    .genders {
      margin-top: 31px;

      .genders__male {
        @media screen and (max-width: 768px) {
          margin-right: 20px;
        }
      }
    }

    .field {
      padding: 0;
      margin-top: 16px;

      .input {
        margin: 0;
      }
    }

    .isUnderThen18 {
      width: 100%;
      max-width: 536px;
      height: 234px;
      border-radius: 8px;
      border: 1px solid #bdc2c6;
      background-color: #ebf0f5;
      padding: 8px 32px;
      margin-top: 18px;
    }

    &__title {
      font-family: $oscine-font-family;
      font-size: 18px;
      font-weight: bold;
      line-height: 1.33;
      color: #595959;
      padding-top: 40px;

      @media screen and (max-width: 450px) {
        font-size: 16px;
      }
    }

    &__label {
      font-weight: normal;
    }

    &__groupFields {
      width: 100%;
      display: flex;

      @media screen and (max-width: 425px) {
        display: block;
      }
    }

    &__button {
      width: 100%;
      max-width: 536px;
      height: 48px;
      border-radius: 30px;
      background-color: $color-purple-heart;
      border: none;
      color: $white;
      text-transform: uppercase;
      font-size: 16px;
      font-family: $oscine-font-family;
      text-align: center;
      font-weight: bold;
      cursor: pointer;
      margin-top: 40px;

      &:disabled {
        opacity: 0.2;
      }
    }
  }

  .passengerInactive {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;

    &__title {
      font-size: 18px;
      font-family: $oscine-font-family;
      font-weight: bold;
      color: #8e8e93;
      position: relative;
      padding-left: 30px;

      &::before {
        width: 40px;
        height: 40px;
        content: '';
        position: absolute;
        left: -20px;
        top: -8px;
        background: url("~@/assets/icons/passengerPerson.svg") no-repeat center;
      }
    }
  }

  .passangerConfirmation {

    &__container {
      color: $base-color;
      height: 145px;
      padding: 20px 38px;
    }

    &__iconCheck {
      background-image: url(~@/assets/icons/check-confirmation.svg);
      background-position: center;
      position: absolute;
      height: 24px;
      left: 24px;
      top: 30px;
      width: 24px;
    }

    &__iconEdit {
      cursor: pointer;
      background-image: url(~@/assets/icons/edit.svg);
      background-repeat: no-repeat;
      background-position: center;
      height: 32px;
      right: 70px;
      position: absolute;
      top: 30px;
      width: 32px;
      display: flex;
      align-items: center;

      b {
        font-family: $rubik-font-family;
        font-size: 16px;
        color: #595959;
        line-height: 1.5;
        font-weight: normal;
        padding-left: 35px;
        font-style: normal;
      }
    }

    &__name {
      font-size: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #444444;
      font-weight: bold;
    }

    &__label {
      font-family: $rubik-font-family;
      font-size: 14px;
      color: #595959;

      b {
        font-weight: normal;

        @media screen and (max-width: 425px) {
          display: none;
        }
      }
    }
  }
}
</style>
